import React, { useEffect, useRef, useState } from 'react';
import styles from './EventSection.module.css';

// Replace these with your actual local image paths

import { useNavigate } from 'react-router-dom';

const EventSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  const events = [
    {
      title: "Bar Nights",
      desc: "Expect strong mixes, good music, and a crowd that knows how to stay a little longer, where the energy carries through the night, building naturally as conversations flow, the music deepens, and the atmosphere stays alive well into the early hours.",
      capacity: "140 seated",
      image: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/LAH%20-%2021.jpg',
      showBtn: false
    },
    {
      title: "Curated Dining Experiences",
      desc: "A more refined way to experience the kitchen, with dishes crafted to be explored on a single plate, bringing together diverse elements and elevated flavours, transforming the ordinary into something thoughtfully composed, balanced, and distinctly memorable.",
      capacity: "140 seated",
      image: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/curated%20event1.png',
      showBtn: false
    },
    {
      title: "Private Events & Celebrations",
      desc: "A setting designed for celebrations that feel personal and well put together, where every detail is thoughtfully considered to match the occasion. It’s a space that allows every moment to unfold naturally, turning simple gatherings into lasting, memorable experiences.",
      capacity: "140 seated",
      image: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/corporate%20image%20(1)%20(1).jpg',
      showBtn: true
    },
    {
      title: "Corporate Events",
      desc: "Ideal for team events, brand evenings, and networking experiences that stand out, with an environment that encourages connection while maintaining a refined edge, ensuring every interaction feels natural, engaging, and well-paced",
      capacity: "140 seated",
      image: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/There%E2%80%99s%20something%20about%20the%20way%20Baglami%20welcomes%20you%20in.%20It%E2%80%99s%20the%20kind%20of%20space%20that%20makes%20you%20w.jpg',
      showBtn: true
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const navigate = useNavigate()

  const navigateToContacts = () => {
    navigate('/contact')
  }

  return (
    <section
      ref={sectionRef}
      className={`${styles.wrapper} ${visible ? styles.show : ""}`}
    >
      <div className={styles.container}>

        {/* Header Section */}
        <header className={styles.header}>
          <h1 className={styles.animateFade}>Events At Baglami</h1>
          <p className={`${styles.animateFade} ${styles.delay1}`}>
           From high-energy bar nights to intimate dining experiences, every event at Baglami is designed to feel distinct and thoughtfully curated. Whether you’re here for music, food, or a celebration, the atmosphere evolves with every occasion, shifting naturally as the night unfolds. Each experience carries its own rhythm, bringing together people, flavour, and energy in a way that feels seamless, engaging, and consistently memorable
          </p>
        </header>

        {/* Events Grid */}
        <div className={styles.grid}>
          {events.map((event, index) => (
            <div
              key={index}
              className={styles.card}
              style={{ transitionDelay: `${(index + 2) * 150}ms` }} // Starts after header animations
            >
              <div className={styles.imageWrapper}>
                <img src={event.image} alt={event.title} loading="lazy" />
              </div>
              <div className={styles.content}>
                <h3>{event.title}</h3>
                <p className={styles.description}>{event.desc}</p>
                <p className={styles.capacity}>
                  {/* <strong>Capacity:</strong> {event.capacity} */}
                </p>
                {event.showBtn && (
                  <button onClick={navigateToContacts} className={styles.inquireBtn}>Inquire</button>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default EventSection;